export default {"src":"/_next/static/media/vaccination-card.3addee3c.svg","height":340,"width":512,"blurWidth":0,"blurHeight":0};